/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import Contentstack from "contentstack";

//environment variable configuration
const Stack = Contentstack.Stack(
  `${process.env.REACT_APP_CONTENTSTACK_API_KEY}`,
  `${process.env.REACT_APP_DELIVERY_TOKEN}`,
  `${process.env.REACT_APP_CMS_ENVIRONMENT}`
);
/**
 * This method is used to set the contentTypeId of the content
 * @param {string} contentTypeId
 *
 */

export const getContentFromContentStack = (contentTypeId: string) => {
  var languageTypeOfPage = window.location.pathname.includes("/admin")
    ? "en-us"
    : sessionStorage.getItem("languageTypeOfApp") || "en-us";

  return Stack.ContentType(contentTypeId)
    .Query()
    .language(languageTypeOfPage)
    .toJSON()
    .find()
    .then((result) => {
      return result;
    })
    .catch((error) => {
      return error;
    });
};
